import { Box, Tag } from '@factorialco/deprecated-design-system'
import { TrainingsTrainingMembershipStatusEnum } from 'generated/resources/graphql'

import { useTrainingsDatatable } from 'modules/trainings/hooks/useTrainingsDatatable'

interface Props {
  status: TrainingsTrainingMembershipStatusEnum
}
export const TrainingStatusTag = ({ status }: Props) => {
  const { getTrainingAttendanceColor, getTrainingAttendanceTranslation } = useTrainingsDatatable()

  return (
    <Box width="fit-content">
      <Tag type={getTrainingAttendanceColor(status)}>
        {getTrainingAttendanceTranslation(status)}
      </Tag>
    </Box>
  )
}
